export default __webpack_public_path__ + "static/media/mh-2.5d6c3708.png";